import { gql } from '@apollo/client';

export const GET_METRIC_GROUPS_QUERY = gql`
  query getMetricGroupsQuery(
    $master_list: Boolean
    $group_id: String
    $company_id: String
    $id: String
  ) {
    metric_groups(
      master_list: $master_list
      group_id: $group_id
      company_id: $company_id
      id: $id
    ) {
      id
      deleted
      name
      description
      master_list_metric_group {
        id
        parentPath
        path
      }
    }
  }
`;

export const GET_METRIC_GROUP_QUERY = gql`
  query getMetricGroupsQuery(
    $master_list: Boolean
    $metric_group_name: String
    $group_id: String
    $company_id: String
    $deleted: Boolean
  ) {
    metric_group(
      master_list: $master_list
      metric_group_name: $metric_group_name
      group_id: $group_id
      company_id: $company_id
      deleted: $deleted
    ) {
      id
      deleted
      name
      description
      master_list_metric_group {
        id
        parentPath
        path
      }
    }
  }
`;
